import { LabelColor } from "types/locationManagement/labelColor";

export type LocationManagementLocationType = {
  id: string;
  name: string;
  allowNestedLocations: boolean;
  labelColorId?: string;
  labelColor?: LabelColor | null;
};

export const defaultLocationManagementLocationType: LocationManagementLocationType = {
  id: "",
  name: "",
  allowNestedLocations: false,
  labelColorId: "",
  labelColor: null,
};
